import React from 'react'

const Home = () => {
  return (
    <div className='home'>
    <h1>Home</h1>
    <h4>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia delectus molestias nostrum ab soluta tempora possimus excepturi quas, sed sunt laboriosam. Tempora debitis harum fuga repellat ipsum deserunt exercitationem maiores optio placeat reiciendis velit delectus repudiandae, eaque totam voluptatibus ipsa? Minima fugit cum nisi recusandae animi quos perspiciatis numquam excepturi</h4>
    </div>
  )
}

export default Home